<template>
  <div>
    <v-container align-center fill-height v-if="viewLoading">
      <v-layout align-center class="pt-4" column style="height: 200px">
        <v-progress-circular
          :color="'accent'"
          :value="100"
          size="50"
          indeterminate
        ></v-progress-circular>
        <!--<v-btn @click="goTo()">跳转</v-btn>-->
      </v-layout>
      <!--  <v-btn @click="autoDialog.activted=true">测试</v-btn>
       <v-dialog v-model="autoDialog.activted">
         <v-layout column>
           <v-card class="pa-3">
             <v-card-title>
               <h3>如要进行后续操作，请输入手机号，系统将认证你为访客用户。</h3>
             </v-card-title>
             <v-form ref="autoTransForm">
               <v-layout column>
                 <v-text-field v-model="autoDialog.phone" :rules="[$rules.requiredS()]" label="手机号" prepend-icon="mdi-phone"></v-text-field>
                 <v-layout justify-center class="pl-2 pr-2">
                   <v-btn class="primary" @click="autoTrans()">确定</v-btn>
                   <v-btn class="warning" @click="goToBindUser()">进行其他身份认证</v-btn>
                 </v-layout>
               </v-layout>
             </v-form>
           </v-card>
         </v-layout>
       </v-dialog>-->
    </v-container>
      <v-layout v-else>
        <v-flex xs12>
          <v-card class="pa-3">
            <v-layout justify-center class="mt-2 pt-3">
              【人行预约】<p  class="primary--text">{{reservation.name}}</p>
            </v-layout>
            <v-layout  column class="ml-2 mr-2">
              <v-flex>
                <v-textarea
                  v-model="reservation.description"
                  prepend-icon="mdi-text"
                  rows="1"
                  auto-grow
                  label="自助预约活动描述"
                  readonly
                >
                </v-textarea>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="registerForm.startDatetime"
                  prepend-icon="mdi-clock"
                  label="最早授权进场时间"
                  readonly
                >
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="registerForm.endDatetime"
                  prepend-icon="mdi-clock"
                  label="最迟要求离场时间"
                  readonly
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <h3 class="error--text">{{unUseReasonTitle}}</h3>
                <p class="error--text" style="font-size: 16px" v-html="unUseReason"></p>
              </v-flex>
            </v-layout>
            <!-- <div class="mt-3">
                 <span class="primary&#45;&#45;text ml-4 mt-5">函件预约规则管理</span>
             </div>-->
            <v-divider></v-divider>
            <v-form ref="registerForm" class="pa-2" v-if="useFlag===true">
              <v-layout column>
                <v-flex xs6>
                  <v-text-field
                    v-model="registerForm.ownerTel"
                    label="手机号码*"
                    :disabled="disabledFlag===true||hasPhone"
                    prepend-icon="mdi-phone"
                    :rules="$rules.phone11()"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout column>
                <v-flex xs6>
                  <v-text-field
                    :label="'证件号码(选填)'"
                    v-model="registerForm.ownerIDNumber"
                    :disabled="disabledFlag===true"
                    prepend-icon="mdi-account-card-details"
                    ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout v-if="!hasPerson">
                <v-flex xs9>
                  <v-text-field
                    class="pb-1"
                    single-line
                    prepend-icon="$vuetify.icons.code"
                    label="验证码"
                    placeholder="请输入验证码"
                    v-model="verifyObj.verifyCode"
                    :disabled="disabledFlag===true"
                    :error-messages="(disabledFlag===true)?'':verifyObj.errorMessage"
                  ></v-text-field>
                </v-flex>
                <v-btn flat color="primary" @click="getTmpToken();verifyObj.getFlag=true" :disabled="disabledFlag===true" v-if="verifyObj.expire<=0">
                  <span>点击获取短信验证码</span>
                </v-btn>
                <span v-else style="font-size: 16px">{{verifyObj.expire}}s</span>
              </v-layout>
            </v-form>
            <v-layout justify-center>
              <v-btn class="primary" :loading="loading" @click="submitForm()" :disabled="disabledFlag===true||(!hasPerson&&verifyObj.verifyCode.length!==4)">提交</v-btn>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>
<script>
import LPlatePicker from '../../../components/LPlatePicker'
import {VIOLATION_ROLE} from '../../../object'
import {ReservationGroup, ReservationAuthority, Reservation} from '../../../object'
function LoginInfo ({token, name, id}) {
  this.token = token || ''
  this.name = name || ''
  this.id = id || ''
  // this.permission = permission || {}
}
import {time} from '../../../ladmin/utils/time'
function VisitorVehicle (id = 0, p = '', t = '', n = '', o = '', idt = '', idn = '') {
  return {
    id: id,
    plate: p,
    ownerTel: t,
    ownerName: n,
    ownerOrg: o,
    ownerIDNumber: idn,
    ownerIDType: idt,
  }
}
export default{
  components: {
    LPlatePicker,
  },
  data () {
    return {
      hasPhone:false,
      hasPerson:false,
      viewLoading:true,
      reservation: new ReservationGroup(),
      interviewee: '',
      showControllers: false,
      selfSignInfo: {
        signUrl: '',
        total: '',
        qrcodeUrl: '',
        stTime:'',
        edTime:''
      },
      verifyObj: {
        show: false,
        getFlag: false,
        expire: 0,
        key: '',
        verifyCode: '',
        verifyKey: '',
        errorMsg: ''
      },
      loginInfo:{},
      registerForm: {
        startDatetime:'',
        endDatetime:'',
        ownerName: '',
        ownerIDType: 'idCard',
        ownerIDNumber: '',
        plate: '',
        ownerTel: '',
        ownerOrg: '',
        typeSelect: [
          {
            text: '居民身份证',
            value: 'idCard'
          },
          {
            text: '军官证|警官证|士兵证',
            value: 'osCard'
          },
          {
            text: '护照',
            value: 'passport'
          },
          {
            text: '港澳|台湾居民来往内地通行证',
            value: 'mtPermit'
          }
        ]
      },
      loading: false,
      disabledFlag: false,
      useFlag: true,
      unUseReason: '',
      unUseReasonTitle: '',
      submitDisabled: true
    }
  },
  methods: {
    async getTmpToken () {
      if (!this.$refs.registerForm.validate()) {
        alert('表单存在不合法数据，请先完善表单')
        return
      }
      this.verifyObjReset()
      this.disabledFlag = true
      let res = await this.$store.dispatch('letterReservation/selfSign_getTmpToken')
      this.disabledFlag = false
      if (res.data.status === 1) {
        this.verifyObj.key = res.data.data.key
        this.verifyObj.expire = 60
        this.sendVertifyMessage()
      }
      else {
        this.verifyObjReset()
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    async sendVertifyMessage () {
      this.disabledFlag = true
      let res = await this.$store.dispatch('letterReservation/selfSign_getVerifyMsg', {key: this.verifyObj.key, phone: this.registerForm.ownerTel})
      this.disabledFlag = false
      if (res.data.status === 1) {
        this.verifyObj.verifyKey = res.data.data.verifyKey
      }
      else {
        this.verifyObjReset()
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    async checkCode () {
      this.loading = true
      this.disabledFlag = true
      let config = {
        'verifyKey': this.verifyObj.verifyKey,
        'realMsg': this.verifyObj.verifyCode
      }
      let res = await this.$store.dispatch('letterReservation/selfSign_checkVerify', config)
      console.log(res)
      if (res.data.status === 1) {
        return true
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
        this.loading = false
        this.disabledFlag = false
        this.verifyObj.expire = -1
        this.verifyObj.errorMsg = res.data.msg + ',请重新获取'
        return false
      }
    },
    verifyObjReset () {
      this.verifyObj.show = false
      this.verifyObj.getFlag = false
      this.verifyObj.verifyCode = ''
      this.verifyObj.errorMsg = ''
      this.verifyObj.expire = 0
    },
    getUserInfo () {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    dealExtend (item) {
      //console.log(item)
      if (item.obgrp.extend !== null) {
        let extend = JSON.parse(item.obgrp.extend)
        //console.log(extend)
        if (extend.qrcodePath !== undefined) {
          this.selfSignInfo.signUrl = '/qrcode' + extend.qrcodePath
          this.selfSignInfo.total = extend.total
          this.selfSignInfo.qrcodeUrl = extend.qrcodeUrl
          this.selfSignInfo.stTime = time.stringify(extend.selfCheckStTime)
          this.selfSignInfo.edTime = time.stringify(extend.selfCheckEdTime)
          this.checkTime()
        }
      }
    },
    async getReservationInfo () {
      let {items} = await this.$store.dispatch('personReservation/getReservationGroups', {
        pagination: {},
        search: {key: 'id', value: this.$route.query.obgrpId},
      })
      // console.log(items)
      if (items.length) {
        let item = items[0]
        this.dealExtend(item)
        item.editInfo = false
        item.loading = false
        this.reservation.name = item.obgrp.name
        this.reservation.description = item.obgrp.description
        this.reservation.id = item.obgrp.id
        this.reservation.owner = {loginId: this.loginInfo.id}
        this.reservation.applicant = {loginId: this.loginInfo.id}
        await this.getRules()
        this.viewLoading = false
      }
      else {
        this.$L.alert('error', '未找到该预约分组')
      }
    },
    checkTime(){
      let d = new Date().getTime()
      let st = time.toTimeStamp(this.selfSignInfo.stTime)
      let ed = time.toTimeStamp(this.selfSignInfo.edTime)
      if(d<st){
        this.disabledFlag = true
        this.useFlag = false
        this.unUseReasonTitle = "【二维码待启用】"
        this.unUseReason = "行人进校自助登记二维码待启用</br>启用时间:</br>"+this.selfSignInfo.stTime+'-'+this.selfSignInfo.edTime+"</br>"+"若有疑问，请联系活动主办单位!"
      }else if(d>ed){
        this.disabledFlag = true
        this.useFlag = false
        this.unUseReasonTitle = "【二维码已过期】"
        this.unUseReason = "行人进校自助登记二维码已过期</br>有效时间:</br>"+this.selfSignInfo.stTime+'-'+this.selfSignInfo.edTime+"</br>"+"若有疑问，请联系活动主办单位!"
      }
    },
    addVehicle () {
      if (this.$refs.registerForm.validate()) {
        // console.log('valid', this.addVehicleForm)
        let f = this.registerForm
        f.plate = f.ownerTel
        // this.$nextTick(() => {
        this.reservation.vehicles.push(new VisitorVehicle(
          this.reservation.vehicles.length,
          f.plate,
          f.ownerTel,
          f.ownerName,
          f.ownerOrg,
          "",
          "",
        ))
        if (f.ownerIDNumber !== '') {
          f.plate = f.ownerIDNumber
          this.reservation.vehicles.push(new VisitorVehicle(
            this.reservation.vehicles.length,
            f.plate,
            f.ownerTel,
            f.ownerName,
            f.ownerOrg,
            "idCard",
            f.ownerIDNumber,
          ))
        }
        return true
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
        return false
      }
    },
    async submitForm () {
      if (!this.addVehicle()) {
        return
      }
      let isTrans = true
      if(this.$route.query.openId!==undefined){
        //alert('1')
        isTrans = await this.autoTrans()
      }
      if(isTrans){
        this.loading = true
        try {
            let res = await this.$store.dispatch('personReservation/submitReservation', {
              reservationGroup: this.reservation,
              type: 'admin',
            })
            this.$L.alert('success', {message: '预约成功'})
            this.disabledFlag = true
        }
        catch (e) {
          console.log(e)
          this.$L.alert("error",{message:e.message})
        }
        finally {
          this.loading = false
        }
      }
    },
    async autoTrans(){
      let checkRes = await this.checkCode()
      if(checkRes){
        let param = {
          verifyKey:this.verifyObj.verifyKey,
          username: '',
          password: '',
        }
        let res = await this.$store.dispatch('wx/bindUser', {
          param: param,
          openId: this.$route.query.openId,
          phone: this.registerForm.ownerTel,
        })
        if (res.data.status === 1) {
          this.$L.alert('success', {message: '注册成功'})
          let loginInfo = new LoginInfo({
            token: res.data.data.Authorization,
            name: res.data.data.name,
            id: res.data.data.username
          })
          sessionStorage.setItem('isWxLogin', 'true')
          this.loginInfo = loginInfo
          sessionStorage.setItem('loginInfo',loginInfo)
          await this.$store.commit('login/saveInfo', loginInfo)
          return true
        }else{
          this.$L.alert('error', {message: '注册失败，原因是'+res.data.msg})
          return false
        }
      }
      else{
        this.$L.alert('error',{message:'验证码错误，请重新获取后提交'})
      }
    },
    async getRules () {
      try {
        // Fixme 需要从页面上支持分页
        let {items} = await this.$store.dispatch('personReservation/getRules', {
          groupId: this.reservation.id,
          pagination: {page: 1, rowsPerPage: 100},
        })
        //console.log(items)
        let rules = []
        let failureRules = []
        for (let i = 0; i < items.length; i++) {
          let rule = items[i]
          if (rule.status === '-1') {
            failureRules.push(rule)
          }
          else {
           rules.push(rule)
          }
        }
        if(rules.length===0){
          this.$L.alert('error',{message:'未查询到分组规则'})
        }
        this.registerForm.startDatetime = rules[0].startDatetime
        this.registerForm.endDatetime = rules[0].endDatetime
        return
      }
      catch (e) {
        console.error(e)
        this.$L.alert('error', e.message)
      }
    },
    async getPersonInfo(){
      let p = await this.$store.dispatch('login/getSelfInfo')
      if(p.phone !== ''){
        this.hasPhone = true
        this.registerForm.ownerTel = p.phone
      }
    }
  },
  created () {
   this.getReservationInfo()
    if(this.$route.query.openId===undefined){
      this.hasPerson = true
      this.getPersonInfo()
    }

  },
  mounted () {
    this.$refs.registerForm.validate()
  },
  watch: {
    'verifyObj.expire' (val, oldVal) {
      if (val > 0) {
        if (val > oldVal) {
          setTimeout(() => {
            this.verifyObj.expire = val - 1
          }, 1000)
        }
        else {
          setTimeout(() => {
            this.verifyObj.expire -= 1
          }, 1000)
        }
      }
      else if (val === 0) {
        this.verifyObj.errorMessage = '验证码已过期，请重新获取'
      }
      else {}
    },
    /*  'registerForm.veCode'(val,oldVal){
        //console.log("123123");
          this.registerForm.veCode = this.registerForm.veCode.toUpperCase();
      }, */
    'verifyObj.verifyCode' () {
      // console.log('change')
      this.verifyObj.errorMessage = ''
      if (this.verifyObj.verifyCode.length === 4) {
        this.submitDisabled = false
      }
    }
  }
}
</script>
<style>

</style>
